/* theme.js · crosshair cursor, system flash, scroll reveals */
(function () {
  var html = document.documentElement;
  var body = document.body;

  function initCursor() {
    if (html.getAttribute('data-cursor') !== 'crosshair') return;
    if (!window.matchMedia('(pointer:fine)').matches || window.innerWidth < 760) return;
    var dot = document.querySelector('.cursor-dot');
    if (!dot) return;
    body.classList.add('cursor-on');
    window.addEventListener('mousemove', function (e) {
      dot.style.transform = 'translate(' + (e.clientX - 11) + 'px,' + (e.clientY - 11) + 'px)';
    }, { passive: true });
    if (motionActive()) initCursorExtras(dot);
  }

  // cursor contextual: cresce sobre alvos; magnetismo leve nas CTAs (.add).
  function initCursorExtras(dot) {
    if (!dot) return;
    document.addEventListener('mouseover', function (e) {
      var t = e.target.closest && e.target.closest('a,button,.card');
      body.classList.toggle('cursor-lg', !!t);
    });
    document.querySelectorAll('.add').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var mx = e.clientX - (r.left + r.width / 2);
        var my = e.clientY - (r.top + r.height / 2);
        btn.style.transform = 'translate(' + (mx * 0.15) + 'px,' + (my * 0.15) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* visibleBrand SAIU: ela existia para o runExit medir a marca renderizada e
     calcular --brand-travel em runtime. O gesto do logo virou View Transition
     nativa (transitions.css), onde a posicao dos dois estados e do navegador e
     nao ha o que medir. Quem garante "so uma marca por vez" agora e o CSS, por
     media query, e nao mais uma varredura de offsetParent. */

  /* --header-h: FONTE UNICA da altura do header.
     Mede o header real e publica no <html>. CSS (--page-pt, o painel mobile, os
     keyframes de entrada) e JS leem daqui. Substitui 53px/50px/104px cravados. */
  function initHeaderHeight() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    function publish() {
      var h = Math.round(header.getBoundingClientRect().height);
      if (h > 0) html.style.setProperty('--header-h', h + 'px');
    }
    publish();
    if ('ResizeObserver' in window) {
      new ResizeObserver(publish).observe(header);
    } else {
      window.addEventListener('resize', publish); // fallback sem RO
    }
    window.addEventListener('orientationchange', publish);
  }

  /* Painel de navegacao. Ele NAO escreve document.body.style.overflow — pede a
     trava ao scroll-lock.js, que virou o dono unico quando o carrinho e o
     lightbox pararam de escrever direto tambem.

     O comentario que morava aqui dizia que o painel nao travava "de proposito,
     porque um terceiro dono do mesmo lock quebraria o ESC em camadas". A
     premissa estava certa: com cada componente escrevendo no mesmo lugar, o
     terceiro quebrava mesmo. O que mudou foi o modelo, nao a regra.

     QUEM TRAVA E DECLARADO NO MARKUP, em data-nav-lock, e so o painel mobile o
     tem. O desktop cabe em 60vh dentro da barra e nao precisa. Isso e decisao de
     desenho, entao mora no header.liquid junto com o desenho — uma media query
     em JS aqui teria que ser mantida em sincronia com o breakpoint do CSS na
     mao, e as duas divergiriam no primeiro dia em que alguem mexesse num so. */
  var navToggles = [];   // preenchido por initNavPanels; usado pelo recolhimento
  /* Onde a pagina esta, na visao do recolhimento. Hoje so o IntersectionObserver
     escreve; ficou porque a proxima pessoa que precisar saber "estou no topo?"
     fora do observer vai procurar exatamente isto, e recriar a variavel em outro
     lugar e como as duas fontes divergem. Comeca em true porque toda pagina abre
     no topo. */
  var noTopo = true;

  function closeAllNavPanels() {
    navToggles.forEach(function (t) { t.setOpen(false); });
  }

  /* Um caminho so para os DOIS hamburgueres (desktop e mobile). O estado mora
     numa classe .nav-open no proprio header, e o CSS anima por transform /
     max-height — antes o mobile abria com [hidden], que nao anima nada. */
  function initNavPanels() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var btns = document.querySelectorAll('[data-nav-toggle]');
    if (!btns.length) return;

    [].forEach.call(btns, function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      /* o nome do detentor sai do id do painel: dois paineis nunca disputam a
         mesma entrada, e quem depurar no console ve qual deles esta segurando. */
      var lockName = panel.hasAttribute('data-nav-lock') ? 'nav:' + panel.id : null;
      var api = {
        setOpen: function (open) {
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          header.classList.toggle('nav-open', open);
          if (!lockName) return;
          if (open) window.SXE.scrollLock.acquire(lockName);
          else window.SXE.scrollLock.release(lockName);
        }
      };
      navToggles.push(api);
      btn.addEventListener('click', function () {
        api.setOpen(btn.getAttribute('aria-expanded') !== 'true');
      });
      var loc = panel.querySelector('select[name="country_code"]');
      if (loc) loc.addEventListener('change', function () { loc.form && loc.form.submit(); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      /* O CARRINHO E A CAMADA DE CIMA: enquanto ele estiver aberto, este ESC nao
         faz nada. O evento segue para o cart.js, que fecha o carrinho, e a nav
         FICA aberta — a pessoa volta para a navbar em vez de perder as duas de
         uma vez. O proximo ESC chega aqui com o carrinho ja fechado e ai sim
         recolhe o painel. E a mesma mecanica do clique fora, na tecla.

         CAPTURA, E NAO BOLHA, e a fase e o mecanismo. O cart.js tira a classe
         cart-open ao fechar; ler o flag em bolha seria uma corrida com o
         handler dele. Listeners de captura no mesmo no rodam ANTES dos de bolha
         independentemente da ordem de registro — hoje o theme.js carrega antes do
         cart.js e isto funcionaria por acidente, mas trocar a ordem dos <script>
         quebraria em silencio, que e o pior modo de falha para uma trava.

         Continua sem preventDefault e sem stopPropagation: o ESC do cart drawer e
         o do lightbox recebem o evento igual. */
      if (html.classList.contains('cart-open')) return;
      // CAMADA PROPRIA: so age se algum painel de nav estiver aberto.
      if (!header.classList.contains('nav-open')) return;
      closeAllNavPanels();
    }, true);
  }

  /* RECOLHIMENTO NO SCROLL. Deteccao por IntersectionObserver num sentinela de
     90px no topo do body: zero listener de scroll, nada para o Lenis disputar. */
  function initHeaderCondense() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    /* SO A HOME TEM A BARRA ALTA. Nas outras paginas ela nasce compacta e FICA,
       independente de scroll — subir de volta ao topo nao a faz crescer.

       A barra alta e a apresentacao da marca: logo grande, os links abertos. Isso
       tem lugar em quem chega pela home. Numa PDP ou numa colecao a pessoa ja
       esta dentro, e o cabecalho e navegacao, nao capa — entao ele comeca no
       tamanho de trabalho e o espaco vai para o produto.

       Quem abre a barra nessas paginas e o hamburguer, e so ele (o CSS abaixo,
       via .nav-open). E uma acao deliberada em vez de um efeito colateral do
       scroll: a pessoa pediu o menu, o menu aparece inteiro.

       A CLASSE NAO E POSTA AQUI — ela vem renderizada do header.liquid. Punha-la
       daqui significava chegar DEPOIS do primeiro paint: a barra nascia alta, o
       CSS via uma mudanca de estado e transicionava, e o usuario via a navbar
       encolher sozinha ao abrir cada pagina interna. Nao era animacao pedida, era
       o conserto aparecendo.

       Aqui so se decide se o estado MUDA com o scroll. Sair cedo sem criar o
       sentinela e o que garante que nada tire a classe depois.

       data-template vem do <body> em theme.liquid, que e o mesmo template.name
       que o header.liquid usa para declarar a classe. Uma fonte, dois leitores. */
    if (document.body.getAttribute('data-template') !== 'index') return;

    if (!('IntersectionObserver' in window)) return; // sem IO: barra fica alta sempre

    var sentinel = document.createElement('span');
    sentinel.className = 'header-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    document.body.insertBefore(sentinel, document.body.firstChild);

    new IntersectionObserver(function (entries) {
      var atTop = entries[0].isIntersecting;
      noTopo = atTop;

      /* NO TOPO, SO O HAMBURGUER SOME. Nada mais se mexe.

         Ele existe apenas com .is-condensed, entao tirar a classe ja o faz sair —
         em fade e colapso de altura, pela transicao que ele sempre teve. Nao ha
         regra nova para "esconder no topo"; ha a AUSENCIA de uma.

         O painel NAO e fechado aqui, e essa e a diferenca. Fechar faria os links do
         painel encolherem enquanto os da barra crescem: duas copias da mesma lista
         em sentidos opostos, que e o "da bagulho louco" relatado. Com o painel
         aberto quem mostra os links e ele, no topo inclusive — e as coordenadas sao
         identicas as do topo fechado (medido: logo 42, vao 26, links 102 nas tres
         telas). Entao nao ha o que animar: a lista ja esta onde ficaria.

         DESCER e que fecha. Ai o gesto e sobre sair dali, e a barra compacta com o
         hamburguer de volta.

         HOUVE UMA VERSAO ANTERIOR que fechava o painel no topo e outra que travava
         o observer inteiro enquanto o menu estava aberto. As duas tratavam sintoma.
         A causa era a geometria nao bater entre as telas; corrigida ela, a regra
         certa e simplesmente nao mexer.

         Menos codigo e o comportamento que ele descreveu: sobe, o hamburguer some
         e o resto fica; desce, compacta e o hamburguer volta. */
      header.classList.toggle('is-condensed', !atTop);
      if (!atTop) closeAllNavPanels();
    }, { threshold: 0 }).observe(sentinel);
  }

  function motionActive() {
    if (!window.SXEMotion) return false;
    // data-motion (setting do dono) E preferencia do sistema. Qualquer um dos
    // dois desligado -> sem animacao. O conteudo continua visivel: initReveal
    // adiciona .in direto neste caminho, e os cliques navegam normal.
    return window.SXEMotion.motionAllowed(
      html.getAttribute('data-motion'),
      window.SXEMotion.prefersReducedMotion()
    );
  }

  /* ============================================================================
     A TRANSICAO DE MARCA SAIU DO JS INTEIRA.
     Removidos: bindIntro, initNavCurtain, runExit — e com eles
     sessionStorage.sxeCurtain, a classe curtain-in e a variavel --brand-travel.

     O DEFEITO QUE ISSO CONSERTA: runExit rodava ANTES de navegar. A sequencia
     real era preventDefault -> 780ms de WAAPI descendo o logo -> so entao
     location.href. Nesses 780ms a pagina antiga estava INTEIRA na tela, e o logo
     descia por cima dela sem nada atras: o fundo e background da .nav-barra e
     nao viaja com a marca. Na arquitetura de cortina funcionava, porque o painel
     opaco escondia a pagina. 5da77ce removeu o painel e manteve a coreografia
     que dependia dele — acoplamento que so existia implicitamente.

     O painel NAO volta. O gesto foi para DENTRO da View Transition, onde a
     pagina antiga e um snapshot congelado e a nova ja existe por baixo: nada
     fica exposto. Ver transitions.css.

     De quebra o tempo caiu: eram 780ms + rede + 520ms de VT, com a subida do
     logo (560ms) sobrepondo. Agora e UMA janela de --dur-curtain.

     bindIntro carregava um orfao vivo: comparava e.animationName com
     'navbarReveal', keyframe que 5da77ce apagou. O animationend nunca casava, e
     so o setTimeout(1200) limpava o curtain-in — 1200ms fixos para uma animacao
     de 560ms.

     O que NAO podia sumir com eles: a limpeza de data-curtain pos-bfcache. Quem
     seta essa flag e o BADGE DIVE, e sem limpeza ela fica presa e
     transitions.js:83 passa a pular TODAS as View Transitions seguintes. Ela
     mudou de dono, para initBfcacheClean, logo abaixo.
     ============================================================================ */
  function initBfcacheClean() {
    // SO em restauracao (e.persisted). Em load normal nao ha resto de transicao
    // para limpar — os estados que existiam (is-cover, curtain-in) nao existem mais.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      html.removeAttribute('data-curtain'); // dono: initBadgeDive
      html.classList.remove('dive-in');     // idem: a capa da dive nao pode voltar acesa
    });
  }


  // BADGE DIVE: transição exclusiva da home → coleção (badge da coleção em destaque).
  // Substitui o cross-document View Transition (instável: badge fantasma / tipos
  // não aplicados). Gesto: o badge dá um ZOOM grande e dissolve sobre um painel
  // que cobre a tela na cor da superfície; ao fim navega, e a página de destino
  // toca a entrada da cortina (curtain-in) — mesma assinatura da navbar.
  function initBadgeDive() {
    var badge = document.querySelector('.hero-dark__badge');
    if (!badge) return;
    var hasMotion = motionActive() && window.Motion && typeof Motion.animate === 'function';
    if (!hasMotion) return; // sem motion: badge navega normal (degradação graciosa)

    // CAPTURE: roda antes do listener (bubble) de transitions.js. preventDefault +
    // stopImmediatePropagation garantem que a VT genérica não dispare nesta navegação.
    badge.addEventListener('click', function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var href = badge.getAttribute('href');
      if (!href) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      runBadgeDive(badge, href);
    }, true);
  }

  function runBadgeDive(badge, href) {
    var fired = false;
    function go() {
      if (fired) return; fired = true;
      // sxeDive (NÃO sxeCurtain): a página de destino pinta atrás de uma capa
      // na cor da superfície que dissolve suave — catálogo surge DEPOIS do badge.
      try { sessionStorage.setItem('sxeDive', '1'); } catch (err) {}
      html.setAttribute('data-curtain', '1'); // avisa transitions.js p/ pular a VT
      window.location.href = href;
    }
    // painel que cobre a tela (eco da cortina). O badge NÃO fica aninhado na home
    // (o z-index não escapava da hierarquia e o painel o cobria → parecia "fade no
    // zoom"). Vai p/ uma camada própria ACIMA do painel, garantindo que ele fique
    // visível por cima enquanto o fundo cobre.
    var panel = document.createElement('div');
    panel.className = 'dive-curtain';
    body.appendChild(panel);

    // Mede a geometria em scale(1). O hover aplica scale(1.035) (hero.liquid) e,
    // como o conteúdo do badge é alinhado à esquerda, medir escalado fixaria o
    // pino numa largura/origem maiores → deslize p/ a esquerda de ~1 frame quando
    // o zoom (que parte de scale(1)) começa. Zera o transform sem transição antes
    // de ler o rect; a animação de zoom abaixo permanece intacta.
    badge.style.transition = 'none';
    badge.style.transform = 'scale(1)';
    void badge.offsetWidth; // reflow síncrono: o rect já reflete scale(1)
    var rect = badge.getBoundingClientRect(); // posição de repouso — fixa o badge AQUI

    var stage = document.createElement('div');
    stage.className = 'dive-stage';
    body.appendChild(stage);
    stage.appendChild(badge); // escapa o stacking context do hero (fica acima do painel)
    // pino na posição original: o badge só dá scale no lugar, sem deslocar p/ o centro
    badge.style.position = 'fixed';
    badge.style.top = rect.top + 'px';
    badge.style.left = rect.left + 'px';
    badge.style.width = rect.width + 'px';
    badge.style.margin = '0';
    badge.style.willChange = 'transform, opacity';
    badge.style.transformOrigin = 'center center'; // zoom cresce do próprio centro, no lugar

    // Coreografia SEQUENCIAL à prova de falha: a animação de opacity só é CRIADA
    // depois do zoom + da segurada, então é impossível o fade andar com o zoom.
    // (1) zoom assenta · (2) badge SEGURA parado no centro (com o fundo na tela) ·
    // (3) só então dissolve em opacity. Navega quando some — destino dá blend.
    var easeCover = [0.4, 0, 0.2, 1];     // espelha --ease-curtain (pouso macio)
    var easeZoom  = [0.22, 1, 0.36, 1];   // ease-out: o zoom assenta suave no fim
    var SCALE = 1.5;  // zoom moderado (não total) — seguro inclusive no mobile
    var ZOOM = 0.55;  // zoom assenta
    var HOLD = 0.6;   // badge parado no centro (a "segurada")
    var FADE = 0.45;  // dissolve suave (não instantâneo)
    var total = ZOOM + HOLD + FADE;

    // painel (cortina) cobre junto com o zoom
    Motion.animate(panel, { opacity: [0, 1] }, { duration: 0.55, easing: easeCover });

    // FASE 1 — zoom
    Motion.animate(badge, { transform: ['scale(1)', 'scale(' + SCALE + ')'] }, { duration: ZOOM, easing: easeZoom })
      .finished
      .then(function () {
        badge.style.transform = 'scale(' + SCALE + ')';  // trava o scale durante a segurada e o fade
        // FASE 2 — segura parado no centro
        return new Promise(function (resolve) { setTimeout(resolve, HOLD * 1000); });
      })
      .then(function () {
        // FASE 3 — só agora cria a animação de opacity (some sozinho, sem zoom)
        return Motion.animate(badge, { opacity: [1, 0] }, { duration: FADE, easing: easeCover }).finished;
      })
      .then(go)
      .catch(function () { go(); });

    setTimeout(go, total * 1000 + 350); // cinto de segurança
  }

  // ENTRADA da dive: cheguei via badge (html.dive-in setado no <head>). A capa
  // .dive-cover já está opaca (cobre o catálogo). Pinto um frame e libero: a capa
  // dissolve (transition CSS) e o catálogo surge suave — DEPOIS do badge sumir.
  function initDiveReveal() {
    if (!html.classList.contains('dive-in')) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { html.classList.remove('dive-in'); });
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (!motionActive() || !('IntersectionObserver' in window)) {
      [].forEach.call(els, function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var v = window.SXEMotion.revealVariant(en.target.getAttribute('data-reveal'));
          en.target.style.transitionDelay = (v.index * 80) + 'ms';
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    [].forEach.call(els, function (el) { io.observe(el); });
    window.__sxeRevealIO = io; // p/ shopify:section:load reusar
  }

  function initLenis() {
    if (!motionActive()) return;
    if (typeof Lenis === 'undefined') return;

    var lenis = new Lenis({
      duration: 1.2,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // parallax-lite: amarra elementos [data-parallax] ao scroll do Lenis (sem 2o listener).
    var plx = document.querySelectorAll('[data-parallax]');
    if (plx.length) {
      lenis.on('scroll', function (e) {
        [].forEach.call(plx, function (el) {
          var speed = parseFloat(el.getAttribute('data-parallax')) || 0.1;
          el.style.transform = 'translateY(' + (e.scroll * speed * -0.1) + 'px)';
        });
      });
    }

    window.lenisInstance = lenis;
  }

  function initLookbookHotspots() {
    var triggers = document.querySelectorAll('.look__hotspot-trigger');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      if (trigger.getAttribute('data-hotspot-bound')) return;
      trigger.setAttribute('data-hotspot-bound', 'true');

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var card = trigger.nextElementSibling;
        if (!card) return;
        var wasHidden = card.hasAttribute('hidden');
        
        // Hide other open hotspot cards
        document.querySelectorAll('.look__hotspot-card').forEach(function (c) {
          c.setAttribute('hidden', '');
        });

        if (wasHidden) {
          card.removeAttribute('hidden');
        } else {
          card.setAttribute('hidden', '');
        }
      });
    });

    // Close cards when clicking anywhere else
    if (!window.SXE.hotspotsGlobalBound) {
      window.SXE.hotspotsGlobalBound = true;
      document.addEventListener('click', function () {
        document.querySelectorAll('.look__hotspot-card').forEach(function (c) {
          c.setAttribute('hidden', '');
        });
      });
    }
  }

  function init() {
    initCursor();
    initBfcacheClean();
    initBadgeDive();
    initDiveReveal();
    initHeaderHeight();
    initNavPanels();
    initHeaderCondense();
    initReveal();
    initLenis();
    initLookbookHotspots();

    document.addEventListener('shopify:section:load', function (e) {
      // o re-bind do header saiu junto com o bindIntro: nao ha mais estado de
      // transicao para religar quando o Customizer repinta a secao. A View
      // Transition e do navegador e o view-transition-name vem do CSS, entao
      // um header recem-inserido ja nasce participando.
      if (e.target.querySelector('.look__hotspot-trigger')) {
        initLookbookHotspots();
      }
      if (window.__sxeRevealIO) {
        var els = e.target.querySelectorAll('[data-reveal]');
        [].forEach.call(els, function (el) { window.__sxeRevealIO.observe(el); });
      }
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
